import React from 'react';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { EVENT_EVENTS } from 'Sp/Angular/Events/Client/Gallery';
import ScreenShotOverlay from 'ts/common/components/gallery/ScreenShotOverlay';
import * as CopyDeter from 'ts/copydeter';

export default [
    'spEventBus',
    '$filter',
    function initCopyDeterWithReactOverlay(spEventBus, $filter) {
        const translateFilter = $filter('translate');

        let inited = false;
        spEventBus.on(EVENT_EVENTS.GOT, (eventData) => {
            if (inited || !eventData?.theme) {
                return;
            }

            if (!eventData.hasAnyScreenshotDeterrence) {
                return;
            }

            inited = true;

            const warningTitle =
                eventData.screenshotDeterrenceDesktopTitle ??
                translateFilter('screenshotWarningTitle');
            const warningBody =
                eventData.screenshotDeterrenceDesktopBody ??
                translateFilter('screenshotWarningBody');

            const renderOverlay = (isKeyboardTrigger) => {
                const el = document.createElement('div');
                const r = createRoot(el);
                flushSync(() => {
                    r.render(
                        React.createElement(ScreenShotOverlay, {
                            colorScheme: eventData.theme?.colorScheme,
                            logoUrl: eventData.theme?.eventBrandLogo?.displayUrl?.original,
                            brandName: eventData.name,
                            isKeyboardTrigger,
                            warningTitle,
                            warningBody
                        })
                    );
                });
                const html = el.innerHTML;
                r.unmount();
                return html;
            };

            const overlayHtml = renderOverlay(true);
            const windowFocusOverlayHtml = renderOverlay(false);

            const targetSelectors = [
                '[data-testid="photoImage"] img',
                // Direct child, not descendant: don't match the <img>s the slideshow/video
                // player renders nested inside .photo-image.
                '.photo-image > img',
                '[data-testid="comparePhotoImage"] img',
                // Slideshow blur mount; filled by createBackdropOverlay.
                '[data-copydeter-backdrop]'
            ];

            CopyDeter.init({
                screenshotProtectionEnabled: eventData.hasScreenshotDeterrenceDesktop,
                windowFocusProtectionLevel: eventData.hasScreenshotDeterrenceDesktop
                    ? 'blur'
                    : 'off',
                mobileProtectionEnabled: !!eventData.screenshotDeterrenceMobileType,
                mobileBlurType: eventData.screenshotDeterrenceMobileType ?? 'diagonal',
                targetSelectors,
                overlayHtml,
                windowFocusOverlayHtml
            });
        });

        spEventBus.emit(EVENT_EVENTS.GET);
    }
];
